import React, {useEffect, useState} from 'react';
import _ from 'lodash';
import CompareItemsTable from "./CompareItemsTable";
import RestoreHiddenItems from "./RestoreHiddenItems";
import {selectHiddenItems, selectValidItems} from "./logic";

export default function CompareItemsApp({
  allItems,
  attributes,
  compatibility,
  vehicle,
  allScores,
  allValues,
}) {
  const [items, setItems] = useState(selectValidItems(allItems));

  const [hiddenItems, setHiddenItems] = useState([]);

  const setVisibleItems = (list) => {
    if (_.isEmpty(list))
      list = selectValidItems(allItems);

    setItems(list);
    setHiddenItems(selectHiddenItems(allItems, list))
  }

  const hideItem = (id) => {
    setVisibleItems(items.filter((item) => item.id != id));
  }

  const restoreAllItems = () => {
    setItems(selectValidItems(allItems));
    setHiddenItems([]);
  }

  // skip first render
  if (_.isEmpty(items))
    return null;

  return <section className="" id="compare-items-container">
    <CompareItemsTable
      items={items}
      attributes={attributes}
      allValues={allValues}
      compatibility={compatibility}
      vehicle={vehicle}
      allScores={allScores}
      hideItem={hideItem}
    />

    <RestoreHiddenItems
      hiddenItems={hiddenItems}
      restoreAllItems={restoreAllItems} />
  </section>

}

